import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { MaskitoDirective } from '@maskito/angular';

@NgModule({
  imports: [CommonModule, TranslateModule, MaskitoDirective],
  providers: [],
  declarations: [],
  exports: [CommonModule, TranslateModule, RouterModule, MaskitoDirective],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
